import { useState, useMemo } from "react";
import { LicenseManager } from "ag-charts-enterprise";
import {
    AGGRID_LICENCE_KEY,
    Utils,
} from "../../../../../shared";
import "ag-charts-community";
import "ag-charts-enterprise";
import { AgCharts } from "ag-charts-react";

LicenseManager.setLicenseKey(AGGRID_LICENCE_KEY);

const OrderProgressCard = ({ plannedAmount = 0, orderedAmount = 0, digitalBudget = 0 }) => {
    // const [shouldIncludeNonDigital] = useState(false);

    const progressPercentage = useMemo(() => {
        const planned = plannedAmount ;
        return planned && planned > 0
            ? (orderedAmount / planned) * 100
            : 0;
    }, [plannedAmount, orderedAmount, digitalBudget]);

    const formatYAxisLabel = (value) => {
        if (value >= 1000000) return `${(value / 1000000).toFixed(0)}M`;
        if (value >= 1000) return `${(value / 1000).toFixed(0)}K`;
        return value.toString();
    };

    const chartOptions = useMemo(
        () => ({
            data: [
                {
                    category: "Planned",
                    value: Number(plannedAmount) 
                },
                {
                    category: "Ordered",
                    value: orderedAmount,
                }
            ],
            series: [
                {
                    type: "bar",
                    xKey: "category",
                    yKey: "value",
                    cornerRadius: 5,
                    itemStyler: (params) => {
                        const isOrdered = params.datum.category === "Ordered";
                        return {
                            fill: isOrdered ? "#2DD4BF" : "#D1D5DB",
                            stroke: isOrdered ? "#2DD4BF" : "#D1D5DB",
                        };
                    },
                    tooltip: {
                        enabled: true,
                        renderer: (params) => {
                            const isPlanned = params.datum.category === 'Planned';
                            const totalPlanned = plannedAmount ;
                            return isPlanned 
                                ? `<div style="padding: 8px;">Total planned: <b>${Utils.formatNumberToUSDCurrency(totalPlanned)}</b></div>`
                                : `<div style="padding: 8px;">Total ordered: <b>${Utils.formatNumberToUSDCurrency(orderedAmount)}</b><br/>Budget remaining: ${Utils.formatNumberToUSDCurrency(totalPlanned - orderedAmount)}</div>`;
                        }
                    }
                },
            ],
            axes: [
                {
                    type: "category",
                    position: "bottom",
                    line: {
                        enabled: true,
                        color: "#E5E7EB",
                    },
                    gridLine: {
                        enabled: false,
                    },
                    label: {
                        rotation: -45,
                        color: "#6B7280",
                        fontSize: 12,
                        fontStyle: "italic",
                    },
                    paddingInner: 0.5,
                    paddingOuter: 0.2,
                },
                {
                    type: "number",
                    position: "left",
                    line: {
                        enabled: false,
                    },
                    label: {
                        enabled: true,
                        color: "#9CA3AF",
                        fontSize: 11,
                        formatter: (params) => formatYAxisLabel(params.value),
                    },
                    gridLine: {
                        style: [{ stroke: '#E5E7EB', lineDash: [4, 4] }],
                    },
                    title: {
                        enabled: true,
                        text: "USD $",
                        color: "#9CA3AF",
                        fontSize: 11,
                    },
                },
            ],
            legend: {
                enabled: false,
            },
            padding: {
                top: 10,
                right: 20,
                bottom: 10,
                left: 10,
            },
        }),
        [plannedAmount, orderedAmount, digitalBudget]
    );
    return (
        <div className="order-progress-card">
            <div className="card-header-section">
                <h3 className="progress-title">Order Progress</h3>
                <div className="percentage-value">{progressPercentage.toFixed(0)}%</div>
                <div className="amount-label">
                    ${(orderedAmount || 0).toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                    })} / ${(plannedAmount || 0).toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                    })}
                </div>
            </div>
            <div className="chart-section">
                <AgCharts options={chartOptions} />
            </div>
        </div>
    );
};

export default OrderProgressCard;
